import { Stack } from '@mui/material'

export function SectionSettingsBulkImport({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <Stack
      className={className}
      sx={{
        paddingX: '16px',
        paddingY: '16px',
      }}
    >
      {children}
    </Stack>
  )
}
